module.exports = __webpack_public_path__ + "static/4-c0829b2bf4d84ae43bd58879ba776846.jpg";